import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { PROFESSIONAL_TYPE_NORMAL } from '../../../../../../define/consts/professional/professional_user';
import { propBool, propId, propNumber, propStr, } from '../../../../../../helpers/custom-prop-types';
import HtmlLink from '../../../../../Ui/Common/HtmlLink';
import Image from '../../../../../Ui/Common/Image';
/**
 * ユーザー情報表示コンポーネント
 * TSの場合は下記を使用する
 * src/components/modules/Image/UserBox/UserBox.tsx
 */
const UserBox = (props) => {
    const { boxClassName, firstName, id, isObjectLink, isShowDetailPage, lastName, organizationName, photo, positionName, type, urlCode, } = props;
    const noLinkComponent = isShowDetailPage ? undefined : 'span';
    const linkUrl = type === PROFESSIONAL_TYPE_NORMAL
        ? `/consultant/${id}`
        : `/free_consultant/${id}`;
    return (_jsxs("div", Object.assign({ className: `rfp_user_box ${boxClassName}` }, { children: [_jsx("div", Object.assign({ className: 'thumbnail_box' }, { children: _jsx(HtmlLink, Object.assign({ isNoLinkComponent: noLinkComponent, isObject: isObjectLink, objectClassName: 'thumbnail_box_object', target: '_blank', to: linkUrl }, { children: _jsx(Image, { alt: '', isObjectFit: true, noImageType: 'user', src: photo, useImage: true }) })) })), _jsxs("div", Object.assign({ className: 'information_box' }, { children: [_jsx(HtmlLink, Object.assign({ className: clsx('name_value', {
                            can_link: !noLinkComponent,
                        }), isNoLinkComponent: noLinkComponent, isObject: isObjectLink, objectClassName: 'name_value_object', target: '_blank', to: linkUrl }, { children: `${lastName} ${firstName}` })), organizationName &&
                        (urlCode ? (_jsx(HtmlLink, Object.assign({ className: 'organization_value can_link', isObject: isObjectLink, objectClassName: 'organization_value_object', target: '_blank', to: `/consultant_unit/${urlCode}` }, { children: organizationName }))) : (_jsx("p", Object.assign({ className: 'organization_value' }, { children: organizationName })))), positionName && _jsx("p", Object.assign({ className: 'position_value' }, { children: positionName }))] }))] })));
};
UserBox.propTypes = {
    boxClassName: propStr(),
    firstName: propStr().isRequired,
    id: propId().isRequired,
    isObjectLink: propBool(),
    isShowDetailPage: propBool().isRequired,
    lastName: propStr().isRequired,
    organizationName: propStr(),
    photo: propStr(),
    positionName: propStr(),
    type: propNumber().isRequired,
    urlCode: propStr(),
};
UserBox.defaultProps = {
    boxClassName: '',
    isObjectLink: false,
    organizationName: '',
    photo: '',
    positionName: '',
    urlCode: '',
};
export default UserBox;
